export default __webpack_public_path__ + "static/media/opensea.1e8a9a04.svg";